/** @format */

import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import SelectDate from "./SelectDate";
import axios from "axios";
import FileSaver from "file-saver";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SelectDropDown from "./SelectDropdown";

function DownloadDispatchReport() {
  const [customersList, setCustomersList] = React.useState([]);
  const [customer, setCustomer] = React.useState("");

  async function getCustomers() {
    try {
      const customerResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/customers`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      setCustomersList(
        customerResponse.data.map((customer) => {
          return {
            name: customer.name,
            value: customer.name,
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  }

  async function getDispatchReport(dispatchData) {
    try {
      const token = JSON.parse(localStorage.getItem("accessToken"));
      if (!token) {
        throw new Error("Access token not found in localStorage");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/report/dispatch-plan`,
        dispatchData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Ensure response is treated as a blob
        }
      );

      console.log("Response received:", response);

      const blob = new Blob([response.data], { type: response.data.type });

      console.log("Blob:", blob);

      FileSaver.saveAs(
        blob,
        `dispatch-report-${dispatchData.fromDate}-${dispatchData.toDate}.xlsx`
      );
    } catch (err) {
      console.error("Error occurred:", err);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const dispatchData = {
      customerName: customer,
      fromDate: data.get("form-date"),
      toDate: data.get("to-date"),
    };

    getDispatchReport(dispatchData);
  }
  useEffect(() => {
    getCustomers();
  }, []);
  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "500px",
        }}>
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <CloudDownloadIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Download Dispatch Clearence Report
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}>
          <SelectDropDown
            options={customersList}
            dropdownLabel={"Select one of the Customer"}
            value={customer}
            setValue={setCustomer}
          />
          <SelectDate dateLabel="Form Date" dateName="form-date" />

          <SelectDate dateLabel="To Date" dateName="to-date" />

          <LoadingButton
            type="submit"
            variant="contained"
            endIcon={<SendIcon />}
            loadingPosition="end"
            sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}>
            submit
          </LoadingButton>
        </Box>
      </Box>
    </>
  );
}

export default DownloadDispatchReport;
